import { Collapse } from '@readcloud/component-library';
import C from 'classnames';
import React, { CSSProperties } from 'react';

export const ToolbarContainer = ({
  className,
  style,
  children,
  topBorder,
  isOpen,
  ...props
}: {
  style?: CSSProperties;
  children?: React.ReactNode;
  className?: string;
  topBorder?: boolean;
  isOpen?: boolean;
}) => {
  return (
    <Collapse
      isOpen={isOpen}
      unmountOnExit
      timeout={250}
      className={C(
        'rc-fixed rc-flex rc-w-full rc-bg-background rc-px-2 toolbar',
        className
      )}
    >
      <div className="rc-w-full">{children}</div>
    </Collapse>
  );
};
